import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
// import withFeatureFlag from 'hoc/featureFlag';
import './index.css';
import * as constants from 'common/constants';

import {
  dashboard,
  fields,
  storage,
  activity,
  contracts,
} from 'common/svg/icons';

const links = [
  {
    route: constants.ROUTE_DASHBOARD,
    text: 'Dashboard',
    icon: dashboard,
  },
  {
    route: constants.ROUTE_FIELDS,
    text: 'Fields',
    icon: fields,
  },
  {
    route: constants.ROUTE_CONTRACTS,
    text: 'Contracts',
    icon: contracts,
  },
  {
    route: constants.ROUTE_STORAGE,
    text: 'Storage',
    icon: storage,
  },
  {
    route: constants.ROUTE_ACTIVITY,
    text: 'Activity',
    icon: activity,
  },
];

const NavigationBar = ({ className }) => {
  const classes = classnames('nav-bar level is-flex', className);

  return (
    <nav className="agi-nav" role="navigation" aria-label="main navigation">
      <ul className={classes}>
        {links.map(link => {
          let dataQA = `button-top-nav-${link.text}`;
          return (
            <li key={link.route} className="nav-link__container is-block">
              <NavLink
                exact={link.route === '/'}
                to={link.route}
                className="nav-link is-flex"
                activeClassName="nav-link--is-active"
              >
                <link.icon width="24px" height="24px" />
                <div className="nav-link__text" data-qa={dataQA}>
                  {link.text}
                </div>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

NavigationBar.propTypes = {
  className: PropTypes.string,
};

// export default withFeatureFlag('showMenu')(NavigationBar);
export default NavigationBar;



// WEBPACK FOOTER //
// ./src/common/components/NavigationBar/index.js